//import { Observable, Observer } from 'rxjs/Rx';
//import { of } from 'rxjs/observable/of';
//import { Injectable, Output, EventEmitter } from '@angular/core';
//import { Http, Response, Headers, RequestOptions } from '@angular/http';
//import { LogService } from '../logger/loggerProvider/loggerhelper.service';
//import { AuthService } from './auth.service';
//import { DashboardConfigManager } from './dashboard.config.service';
import { PMBarChartResponse } from '../../interfaces/pm.barchart.response.interface';
//import * as moment from 'moment';
//import { observeOn } from 'rxjs/operator/observeOn';
//import { forkJoin } from 'rxjs/observable/forkJoin';
import { PmPropertyDescriptionService } from './pm.propertyDescription.service';

//import { Injectable } from '@angular/core';
//import { DataProvider,ParameterService,Widget,DashboardConfigManager,AuthService,LogService } from "core-dashboard";
//import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
// import * as momentNs from 'moment';
// const moment = momentNs;

import { Injectable } from '@angular/core';
import { LogService } from '../../logger/loggerProvider/loggerhelper.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { empty, Observable } from "rxjs";
import { AuthService } from '../auth.service';
import { DashboardConfigManager } from '../dashboard.config.service';
import moment from 'moment';

@Injectable()
export class PmBarchartDataService {
    private locale: any = "en-US";
    private dateLocales: any[] =
    [{ locale: "en-US", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], week: "Week", year: "Year",month:"Month",day:"Day",hour:"Hour", previous: "Previous", current: "Current",currentyear:"Current",currentmonth:"Current",previousyear:"Previous",previousmonth:"Previous"},
    { locale: "de-DE", months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"], week: "Woche", year: "Jahr",month:"Monat",day:"Tag",hour:"Stunde", previous: "Vorherige", current: "Aktuelle",currentyear:"Aktuelles",currentmonth:"Aktueller",previousyear: "Vorheriges",previousmonth: "Vorheriger" },
    {locale:"en-GB",months:["January","February","March","April","May","June","July","August","September","October","November","December"],days: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"], week: "Week", year: "Year",month:"Month",day:"Day",hour:"Hour", previous: "Previous", current: "Current",currentyear:"Current",currentmonth:"Current",previousyear:"Previous",previousmonth:"Previous" },
    {locale:"es-ES",months:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],days: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"], week: "Semana", year: "Año",month:"Mes",day:"Día",hour:"Hora", previous: "Anterior", current: "Actual",currentyear:"Actual",currentmonth:"Actual",previousyear:"Anterior",previousmonth:"Anterior" },
    {locale:"fr-FR",months:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],days: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"], week: "La semaine", year: "Année",month:"Mois",day:"journée",hour:"Heure", previous: "Précédente", current: "Courante",currentyear:"Courante",currentmonth:"Courante",previousyear:"Précédente",previousmonth:"Précédente" },
    {locale:"it-IT",months:["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre"],days: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"], week: "Settimana", year: "Anno",month:"Mese",day:"Giorno",hour:"Ora", previous: "Precedente", current: "Attuale",currentyear:"Attuale",currentmonth:"Attuale",previousyear:"Precedente",previousmonth:"Precedente" },
    {locale:"pl-PL",months:["(styczeń)","(luty)","(marzec)","(kwiecień)","(maj)","(czerwiec)","(lipiec)","(sierpień)","(wrzesień)","(październik)","(listopad)","(grudzień)"],days: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"], week: "Semana", year: "Rok",month:"Miesiąc",day:"Dzień",hour:"Godzina", previous: "Poprzedni", current: "Obecny",currentyear:"Current",currentmonth:"Obecny",previousyear:"Obecny",previousmonth:"Poprzedni" },
    {locale:"pt-PT",months:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],days: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"], week: "Semana", year: "Ano",month:"Mês",day:"Dia",hour:"Hora", previous: "Anterior", current: "Atual",currentyear:"Atual",currentmonth:"Atual",previousyear:"Anterior",previousmonth:"Anterior" },
    {locale:"tr-TR",months:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],days: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"], week: "Hafta", year: "Yıl",month:"Ay",day:"Gün",hour:"Saat", previous: "Önceki", current: "şimdiki",currentyear:"şimdiki",currentmonth:"şimdiki",previousyear:"Önceki",previousmonth:"Önceki" },
    {locale:"zh-CN",months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],days: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"], week: "周", year: "年",month:"月",day:"天",hour:"小时", previous: "以前", current: "当前",currentyear:"Current",currentmonth:"当前",previousyear:"以前",previousmonth:"以前" }
];

    constructor(private authService: AuthService,
        private http: HttpClient,
        private logger: LogService,
        private propDescService: PmPropertyDescriptionService,
        private dashboardConfig: DashboardConfigManager) {
    }

    public getBarchartData(dpName: any, duration: any, interval: any, currentdate: Date, locale: any): Observable<PMBarChartResponse> {
        let dateTimeRange = this.getTimeRangeForTrendSeries(duration, interval, currentdate);

        //this.logger.logInfo('PmBarchartDataService', "locale:" + locale);
        this.locale = (locale != "") ? locale : this.locale;

        this.logger.logInfo('PmBarchartDataService', "mLocale:" + this.locale);
       this.logger.logInfo('PmBarchartDataService',"Datetime range: "+dateTimeRange)
        
        return this.getObservableBardata(dpName, dateTimeRange, duration, interval);
    }

    private getObservableBardata(dpName: any, dateTimeRange: any, duration: any, interval: any): Observable<PMBarChartResponse> {
        let result = Observable.create(observer => {

            if (!dpName)
                return empty();

            let url = this.getUrlForSeries(dpName, dateTimeRange);
            //get token
            if (url != null) {
                let token: any = this.authService.getToken();
                let headers: HttpHeaders = new HttpHeaders({ "Accept": "application/json", "Access-Control-Allow-Origin": "*", "Authorization": "Bearer " + token, });
                this.logger.logInfo("PmBarchartDataService", "Calling WSI API");
                this.http.get(url, {
                    headers: headers, observe: "response"
                }).subscribe((res: HttpResponse<any>) => {
                    try {
                        if (res === null || res.status != 200) {
                            this.logger.logWarning('PmBarchartDataService', "Http Response: " + res)
                        }
                        let responsebody: any = res.body;//.json();
                        let body: any;
                        if (responsebody === null) {
                            let namesplit = dpName.split(':');
                            body = { SeriesPropertyId: namesplit[0] + ':' + namesplit[1], Series: [] };
                        }
                        else {
                            body = { SeriesPropertyId: responsebody.SeriesPropertyId, Series: responsebody.Series };
                        }
                        if (body && body.Series) {
                            let data: any = [];
                            data = this.convertTrendSeriesDataIntoBarchartDataFormat(body.Series, interval, duration, dateTimeRange);

                            // To show point description 
                            let bardata: PMBarChartResponse;
                            bardata =
                                {
                                    DpPropertyDetail: { DataPointDescription: "", DataPointName: "", PropertyDescription: "", PropertyName: body.SeriesPropertyId, Unit: "",Resolution:0 },
                                    ResponseArrayCollection: [data]
                                };
                            if (body.SeriesPropertyId && body.SeriesPropertyId != null) {
                                this.propDescService.getPropertyDetails(body.SeriesPropertyId, headers).subscribe(propertyDetail => {
                                    bardata.DpPropertyDetail = propertyDetail;
                                    observer.next(bardata);
                                    observer.complete();
                                });
                            }
                            else {
                                observer.next(bardata);
                                observer.complete();
                            }
                        }
                    }
                    catch (ex) {
                        this.logger.logError("PmBarchartDataService", "Error while processing response : " + ex);
                    }
                }, (error) => {

                    let errMsg: any = (error && error.message) ? error.message : "Server error";
                    if (this.logger)
                        this.logger.logError("PmBarchartDataService", "Error in received from service: " + errMsg);
                    observer.next(null);
                    observer.complete();
                });
            } else {
                observer.next(null);
                observer.complete();
            }

        })
        this.logger.logInfo("PmBarchartDataService","Result:" +result);       
        return result;
    }
    private getTimeRangeForTrendSeries(duration: any, interval: any, currentdate: Date): any {
        let dateTimeRange: any;
        if (duration !== undefined) {

            if (duration === 'week') {
                dateTimeRange = this.setTimeRangeBasedonDuration("isoWeek", currentdate);
            }
            else
                if (interval !== '1week') {
                    dateTimeRange = this.setTimeRangeBasedonDuration(duration, currentdate);
                }
                else if (interval === '1week' && (duration === 'month' || duration === 'year')) {
                    dateTimeRange = this.setTimeRangeForWeekInterval(duration, currentdate);
                }
                else {
                    this.logger.logWarning('PmBarchartDataService', "Invalid duration & interval Configuration");
                }
        }
        this.logger.logInfo('PmBarchartDataService', "From Range:" + dateTimeRange.From.toLocaleString() + "\t &To:" + dateTimeRange.To.toLocaleString());
        return dateTimeRange;
    }
    private setTimeRangeBasedonDuration(duration: any, currentdate: Date): any {
        let firstdayofmonth = moment(currentdate).startOf(duration);
        let lastdayofmonth = moment(currentdate).endOf(duration);
        let dateTimeRange = { From: firstdayofmonth.toDate(), To: lastdayofmonth.toDate() };
        return dateTimeRange;
    }
    private setTimeRangeForWeekInterval(duration: any, currentdate: Date) {
        if (duration === 'year') {
			//Leap year logic
            //According to ISO week date standard (ISO-8601)
            // Week start date is always Monday and end date is Sunday
            //If Jan 1st falls on Mon-Thu of a week then that will be considered as 1st week of year.
            //All leap year doesn't have 53 weeks. Like (2008,2012,2024)
            //On the other hand, though it's not a leap year it can also have 53 weeks. Like 2009, 2015,2026
            
            let weeksInCurrentYear = moment(currentdate).isoWeeksInYear();
            let from = moment(currentdate).isoWeeks(1).startOf('isoWeek')
			let to = moment(currentdate).isoWeeks(weeksInCurrentYear).endOf('isoWeek')
			let dateTimeRange = { From: from, To: to };
			return dateTimeRange;                                 
        }
        else
	   {
                var startOfMonth = moment(currentdate).startOf('month'); 
                while (startOfMonth.day() !== 4) {
                    startOfMonth.add(1, 'day');
                }
                var from = startOfMonth.subtract(3, 'day').toDate();

                var endOfMonth = moment(currentdate).endOf('month');
                while (endOfMonth.day() !== 4) {
                    endOfMonth.subtract(1, 'day');
                }
                var to = endOfMonth.add(3, 'day').endOf('day').toDate();
                var dateTimeRange = { From: from, To: to };
                return dateTimeRange;
        }
    }

    private getUrlForSeries(seriesID: string, timeRange: any): string {
        let baseUrl = this.dashboardConfig.getBaseUrl();
        let url: string = baseUrl + "/api/trendseries/" + seriesID;

        if (!timeRange.From && !timeRange.To) {
            return url;
        }
        else if (timeRange.From && timeRange.To) {
            timeRange.From = new Date(timeRange.From);
            timeRange.To = new Date(timeRange.To);
            if (Object.prototype.toString.call(timeRange.From) === '[object Date]' && Object.prototype.toString.call((timeRange.To) === '[object Date]'))
                url = url + '?from=' + timeRange.From.toISOString() + '&to=' + timeRange.To.toISOString();
            return url;
        } else {
            this.logger.logWarning('PmBarchartDataService', "Incorrect format of parameter/s From and/or To date.")
            return null;
        }
    }

    private convertTrendSeriesDataIntoBarchartDataFormat(seriesData: any, interval: any, duration: any, barchartTimeRange: any): any {
        let data: any = [];
        for (var i = 0; i < seriesData.length; i++) {
            let obj: any = seriesData[i];
            if (obj) {
                let x: any = new Date(obj.Timestamp.toString());
                let y: number = parseFloat(obj.Value);
                if (x !== undefined && y !== undefined) {
                    data.push({ key: x, value: y });
                }
            }
        }
        let emptyIntervals = this.GetEmptyIntervals(interval, barchartTimeRange);
        var intervalBasedData = emptyIntervals.concat(data);
        //this.logger.logInfo('PmBarchartDataService', "interval Based Data -merged:" + JSON.stringify(intervalBasedData));

        let roundedData: any = [];
        for (var i = 0; i < intervalBasedData.length; i++) {
            let obj: any = intervalBasedData[i];
            if (obj) {
                let x: any = this.roundDateTimeBasedOnIntervel(obj.key.toString(), interval);
                let y: number = parseFloat(obj.value);
                if (x !== undefined && y !== undefined) {
                    roundedData.push({ key: x, value: y });
                }
            }
        }
        //this.logger.logInfo('PmBarchartDataService', " interval Based Data -Rounded:" + JSON.stringify(roundedData));
        let groupedData = this.groupByDateTimeandGetTotalValue(roundedData);
        return this.formatDataForXaxisLabel(groupedData, interval, duration);
    }

    private formatDataForXaxisLabel(groupedData: any, interval: any, duration: any) {
        let formatedData: any = [];
        for (var i = 0; i < groupedData.length; i++) {
            let obj: any = groupedData[i];
            if (obj) {
                let x: any = this.getXaxisLabel(obj.key, interval, duration);

                // Duplicate time values are not accepted in the chart
                // In case of Daylight saving, we need to display the same key twice.
                // Adding a * before the duplicate key so that both will be displayed in the chart
                formatedData.forEach(element => {
                    if (element.key == x){
                        x = "*" + x;
                    }
                });

                let y: number = parseFloat(obj.value);
                if (x !== undefined && y !== undefined) {
                    formatedData.push({ key: x, value: y });
                }
            }
        }
        // this.logger.logInfo('PmBarchartDataService', "date test de-DE: " + moment("2018-01-03T18:30:00.000Z").locale("de-DE").format("MMMM"));
        // this.logger.logInfo('PmBarchartDataService', "date test de: " + moment("2018-01-03T18:30:00.000Z").locale("de").format("MMMM"));
        // this.logger.logInfo('PmBarchartDataService', "date test: " + moment("2018-01-03T18:30:00.000Z").locale(this.locale).format("MMMM"));
        return formatedData;
    }
    private getXaxisLabel(dateTime: any, interval: any, duration: any): any {
        let date: Date = new Date(dateTime.toString());
        let xAxisLabel: any = "";
        if (interval === '1month') {
            xAxisLabel = this.getDateLocale("months", date.getMonth());
            //xAxisLabel = moment(date).locale(this.locale).format("MMMM");
        }
        else if (interval === '1week') {
            xAxisLabel = this.getDateLocale("week",0) + "-" + moment(date).locale(this.locale).format("WW");
        }
        else if (interval === '1year') {
            xAxisLabel = this.getDateLocale("year",0);
        }
        else if (interval === '1day') {
            if (duration === 'week') {
                xAxisLabel = this.getDateLocale("days", date.getDay());
                //xAxisLabel = moment(date).locale(this.locale).format("dddd");
            }
            else {
                xAxisLabel = moment(date).locale(this.locale).format("DD");
            }
        }
        else if (interval === '1hour') {
            xAxisLabel = moment(date).locale(this.locale).format("HH:mm");
        }
        else if (interval === '15minute') {
            if (duration === 'hour') {
                xAxisLabel = moment(date).locale(this.locale).format("00:mm");
            }
            else {
                xAxisLabel = moment(date).locale(this.locale).format("HH:mm");
            }
        }
        return xAxisLabel;
    }

    private groupByDateTimeandGetTotalValue(data: any): any {
        // group the data
        var groupedData = data.reduce(function (l, r) {
            // construct a unique key out of the properties we want to group by
            var key = r.key.toISOString();
            // check if the key is already known
            if (typeof l[key] === "undefined") { // init with an "empty" object
                l[key] = {
                    sum: 0
                };
            }
            // sum up the values that has same time range
            l[key].sum += r.value;
            return l;
        }, {});

        //this.logger.logInfo('PmBarchartDataService', "groupedData-unorganised:" + JSON.stringify(groupedData));

        var avgGroupedData = Object.keys(groupedData)
            .map(function (key) {
                // construct the key value pair of DateTime and sum of values
                return {
                    key: key,
                    value: groupedData[key].sum
                };
            });

        this.logger.logInfo('PmBarchartDataService', "groupedData:" + JSON.stringify(avgGroupedData));
        return avgGroupedData;
    }

    private GetEmptyIntervals(interval: any, barchartTimeRange: any): any {
        let intervals: any = [];
        if (interval === '1month') {
            intervals = this.getIntervalsbyTimeRange(1, 'months', barchartTimeRange);
        }
        else if (interval === '1week') {
            intervals = this.getIntervalsbyTimeRange(1, 'weeks', barchartTimeRange);
        }
        else if (interval === '1day') {
            intervals = this.getIntervalsbyTimeRange(1, 'days', barchartTimeRange);
        }
        else if (interval === '1hour') {
            intervals = this.getIntervalsbyTimeRange(1, 'hours', barchartTimeRange);
        }
        else if (interval === '15minute') {
            intervals = this.getIntervalsbyTimeRange(15, 'minutes', barchartTimeRange);
        }
        else if (interval === '1year') {
            intervals = this.getIntervalsbyTimeRange(1, 'year', barchartTimeRange);
        }
        //this.logger.logInfo('PmBarchartDataService', "timeintervals:" + JSON.stringify(intervals));
        return intervals;
    }
    private getIntervalsbyTimeRange(intervalLength: number, intervalUnit: any, barchartTimeRange: any) {
        let intervals: any = [];
        var timeIntervel = new Date(barchartTimeRange.From.toString());

        timeIntervel.setMinutes(0, 0, 0);
        while (barchartTimeRange.To >= timeIntervel) {
            intervals.push({ key: timeIntervel, value: 0 });
            timeIntervel = moment(timeIntervel).add(intervalLength, intervalUnit).toDate();
        }
        return intervals;
    }

    private roundDateTimeBasedOnIntervel(dateTime: any, interval: any): any {
        var roundedDateTime = new Date(dateTime.toString());

        if (interval === '1month') {
            roundedDateTime.setMonth(roundedDateTime.getMonth(), 1);
            roundedDateTime.setHours(0, 0, 0, 0);//same day but time is reset to 12am for grouping
        }
        else if (interval === '1week') {
            roundedDateTime = moment(roundedDateTime).startOf('isoWeek').toDate();// round it to starting day of the week based on given date
            roundedDateTime.setHours(0, 0, 0, 0);//same day but time is reset to 12am for grouping
        }
        else if (interval === '1day') {
            roundedDateTime.setDate(roundedDateTime.getDate());
            roundedDateTime.setHours(0, 0, 0, 0);//time is reset to 00:00 for grouping
        }
        else if (interval === '1hour') {
            //hourly consumption should be shown in the next hour //minutes are reset to 00 for grouping
            return moment(roundedDateTime).add({minutes:-roundedDateTime.getMinutes(), seconds:-roundedDateTime.getSeconds(), milliseconds:-roundedDateTime.getMilliseconds()}).toDate();
        }
        else if (interval === '15minute') {            
            //rounding up to nearest 15 min
            // Adding the relevant minutes to the moment and subtracting the seconds instead of setting the value to the date
            // As this would affect the daylight saving time changes
            let m = (((roundedDateTime.getMinutes() + 7.5) / 15 | 0) * 15);
            return moment(roundedDateTime).add({minutes:m-roundedDateTime.getMinutes(),seconds:-roundedDateTime.getSeconds(), milliseconds:-roundedDateTime.getMilliseconds()}).toDate();
        }
        else if (interval === '1year') {
            roundedDateTime.setFullYear(roundedDateTime.getFullYear(), 0, 1);
        }
        return roundedDateTime;
    }

    public getDateLocale(key: any, index: number): String {
        let dateLocale = null;
        let formatedPeriod:String = "";
        var dateLocalesFound = this.dateLocales.filter(d => d.locale == this.locale);
        if (dateLocalesFound != null && dateLocalesFound.length > 0) {
            dateLocale = dateLocalesFound[0];
        }
        else {
            dateLocale = this.dateLocales.filter(d => d.locale == "en-US")[0]; //to fetch default locale if the given locale is not present
        }
        if (key == "months") {
            formatedPeriod = dateLocale.months[index];
        }
        else if (key == "days") {
            formatedPeriod = dateLocale.days[index];
        }
        else if (key == "year") {
            formatedPeriod = dateLocale.year;
        } 
        else if (key == "month") {
            formatedPeriod = dateLocale.month;
        } 
        else if (key == "week") {
            formatedPeriod = dateLocale.week;
        } 
        else if (key == "day") {
            formatedPeriod = dateLocale.day;
        }
        else if (key == "hour") {
            formatedPeriod = dateLocale.hour;
        }
        else if (key == "previous") {
            formatedPeriod = dateLocale.previous;
        } 
        else if (key == "current") {
            formatedPeriod = dateLocale.current;
        }
        else if (key == "previousmonth") {
            formatedPeriod = dateLocale.previousmonth;
        } 
        else if (key == "currentmonth") {
            formatedPeriod = dateLocale.currentmonth;
        }
        else if (key == "previousyear") {
            formatedPeriod = dateLocale.previousyear;
        } 
        else if (key == "currentyear") {
            formatedPeriod = dateLocale.currentyear;
        }
        return formatedPeriod;
    }
    
    public getCurrentDate(currentDate:Date,duration:any):Date
    {
        return moment(currentDate.toISOString()).subtract(1, duration).toDate();
    }
}
